var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-layout"},[_c('NavBar'),_c('main',{staticClass:"main-content"},[_c('router-view')],1),_c('Footer'),_c('chat-assistant')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }